import { useDispatch } from 'react-redux';
import { getPerformanceDevelopmentConsultationsCard } from '@/store/slices/components/dashboard/service';
import ConsultedEntities from '../ConsultedEntities';
import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import ChatIcon from '@/public/images/dashboard/chat.svg';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import { useTrackPerformanceTabCard } from '../../customHooks/useTrackDashboard';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';

function MostConsultedDevelopments() {
  const dispatch = useDispatch();
  const track = useTrackPerformanceTabCard();

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'developmentConsultations',
        subkey: 'sortBy',
        value: 'inquiry',
      })
    );
    dispatch(
      setPerformanceModals({
        key: 'developmentConsultations',
        subkey: 'sortDirection',
        value: 'desc',
      })
    );
    dispatch(
      setPerformanceModals({
        key: 'developmentConsultations',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <ConsultedEntities
      id="most-consulted-developments"
      title={Trans(translations, 'MostInquiredDevelopments')}
      stateKey="developmentConsultations"
      stateSubkey="most_consulted"
      entityType="development"
      fetchCallback={(query) =>
        dispatch(getPerformanceDevelopmentConsultationsCard({ query }))
      }
      openTableCallback={handleOpenTable}
      trackCallback={(element) => track.mostInquiriedDevelopments(element)}
      emptyStateChildren={
        <DashboardEmptyStateCard
          icon={ChatIcon}
          title={Trans(
            translations,
            'HereYouWillSeeYourMostInquiredDevelopments'
          )}
          description={Trans(
            translations,
            'PromotingYourDevelopmentsIsKeyToFindLeads'
          )}
        />
      }
    />
  );
}

export default MostConsultedDevelopments;
